module.exports = __webpack_public_path__ + "static/img/guoxiang_wang_cert.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/wmm/guoxiang_wang_cert.jpg
// module id = kLCv
// module chunks = 0